export const groupConstants = {
  SEND_INVITES_REQUEST: 'GROUP/SEND_INVITES_REQUEST',
  SEND_INVITES_SUCCESS: 'GROUP/SEND_INVITES_SUCCESS',
  SEND_INVITES_FAILURE: 'GROUP/SEND_INVITES_FAILURE',

  ADD_COMMENT_REQUEST: 'GROUP/ADD_COMMENT_REQUEST',
  ADD_COMMENT_SUCCESS: 'GROUP/ADD_COMMENT_SUCCESS',
  ADD_COMMENT_FAILURE: 'GROUP/ADD_COMMENT_FAILURE',
  CLEAR_COMMENT_STATE: 'GROUP/CLEAR_COMMENT_STATE'
}
